module.exports = __webpack_public_path__ + "media/images/investor-dreamit-eaef03f0.png";